"use client";

import * as React from "react";
import { cn } from "@/utils";

export type TimelinePoint = {
  label: string;
  date: string;
  detail?: string;
};

export function LaunchTimeline({
  items,
  className,
}: {
  items: TimelinePoint[];
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mb-10 overflow-x-auto pb-2 no-scrollbar",
        className,
      )}
    >
      <div className="relative flex min-w-[44rem] items-start px-2">
        <div
          aria-hidden
          className="absolute left-8 right-8 top-[0.4rem] h-px bg-gradient-to-r from-transparent via-hex-400/35 to-transparent"
        />
        {items.map((item) => (
          <div
            key={item.label}
            className="group relative flex min-w-[8.75rem] flex-1 flex-col items-center px-2 text-center"
          >
            <span className="relative z-10 h-2.5 w-2.5 rounded-full border-2 border-hex-400 bg-primary shadow-[0_0_10px_rgba(255,15,111,0.45)] transition-transform duration-200 group-hover:scale-125" />
            <time className="mt-4 font-mono text-2xs uppercase tracking-wider text-hex-300/90">
              {item.date}
            </time>
            <p className="mt-1.5 text-sm font-medium leading-snug text-white">
              {item.label}
            </p>
            <div className="pointer-events-none absolute top-8 z-20 w-52 rounded-xl border border-white/[0.08] bg-surface-200/95 px-3 py-2.5 text-left text-xs leading-relaxed text-muted opacity-0 shadow-card backdrop-blur-md transition-all duration-200 group-hover:pointer-events-auto group-hover:opacity-100">
              <p className="font-medium text-white/90">{item.label}</p>
              <p className="mt-1">{item.detail ?? "Market launch date used for ROI normalization."}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LaunchTimeline;
